import { Flex } from "./Grid";
import { Icon } from "./Icon";
import { Callout, Title2 } from "./Typography";

interface LockedOverlayProps {
  title: string;
  body: string;
}

export const LockedOverlay = ({ title, body }: LockedOverlayProps) => {
  return (
    <div
      css={`
        position: absolute;
        inset: 0;
        z-index: 2;
        background: rgba(0, 0, 0, 0.25);
        backdrop-filter: blur(2px);
      `}
    >
      <Flex
        direction="column"
        align="center"
        justify="center"
        height={206}
        paddingLeft="md"
        paddingRight="md"
        css={`
          margin: 0 auto;
          max-width: 264px;
        `}
      >
        <Icon name="Lock" height={36} width={36} />

        <Title2
          css={`
            text-align: center;
          `}
        >
          {title}
        </Title2>

        <Callout
          css={`
            text-align: center;
          `}
        >
          {body}
        </Callout>
      </Flex>
    </div>
  );
};
